import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Crown, Heart, Gift } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function WhatIfSection() {
  const {
    t
  } = useTranslation();
  const icons = [<Sparkles className="w-6 h-6 text-lavender-600" key="s" data-id="element-538" />, <Crown className="w-6 h-6 text-gold-500" key="c" data-id="element-539" />, <Heart className="w-6 h-6 text-blush-500" key="h" data-id="element-540" />, <Gift className="w-6 h-6 text-lavender-500" key="g" data-id="element-541" />];
  const features = t.whatIf.features.map((text, i) => ({
    icon: icons[i],
    text
  }));
  return <section className="py-24 bg-cream-100 relative overflow-hidden" data-id="element-542">
      <div className="absolute top-0 left-0 right-0 flex justify-center items-center -mt-3" data-id="element-543">
        <div className="h-px w-full max-w-md bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-544"></div>
        <Sparkles className="w-5 h-5 text-gold-500/50 mx-4" data-id="element-545" />
        <div className="h-px w-full max-w-md bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-546"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-547">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-548">
          <h2 className="font-serif text-4xl md:text-5xl text-gray-900 mb-6" data-id="element-549">
            {t.whatIf.heading1}{' '}
            <span className="text-lavender-600 italic" data-id="element-550">
              {t.whatIf.heading2}
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-551">
            {t.whatIf.intro}
          </p>
          <p className="text-lg text-gray-600 mt-4 font-medium" data-id="element-552">
            {t.whatIf.intro2}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-553">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-lavender-50 flex items-center gap-4 hover:shadow-md transition-shadow" data-id="element-554">
              <div className="w-12 h-12 rounded-full bg-cream-50 flex items-center justify-center flex-shrink-0 border border-lavender-100" data-id="element-555">
                {feature.icon}
              </div>
              <p className="text-gray-800 font-medium text-lg" data-id="element-556">
                {feature.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center" data-id="element-557">
          <p className="font-script text-4xl md:text-5xl text-lavender-600" data-id="element-558">
            {t.whatIf.tagline}
          </p>
        </motion.div>
      </div>
    </section>;
}